import React, { ComponentType } from 'react'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import includes from 'lodash/includes'

import ReactHtmlParser from 'react-html-parser'
import { onButtonTriggerKey } from '../../utils'
import { FormatDate } from '../utils'
import { MarketingProps } from '../MarketingTag'

import { GridViewEntityItemProps, GridViewEntity } from '.'
import OutlookPopup from '../OutlookKey/OutlookPopup'

export type ResultItemRenderLinkProps = Partial<ResultItemProps>

export type ResultItemProps = {
  title?: string
  name?: string
  ultimateParent?: boolean
  issueName?: string
  permalink?: string
  text?: string
  publishedDate?: string
  docType?: string
  reportType?: string
  abstract?: string
  marketing?: MarketingProps
  entityName?: string
  transactionTitle?: string
  ratingsDisplay?: []
  entityRatings?: GridViewEntityItemProps[]
  renderLink: ComponentType<ResultItemRenderLinkProps>
  sectorOutlook?: string
  sectorOutlookCode?: string
}

export type ResultItemsProps = {
  items: ResultItemProps[]
  isPrintPreview?: boolean
}
const TextAbstract = ({ text, abstract }: any) => (
  <>
    {text && <p>{ReactHtmlParser(text)}</p>}
    {abstract && <p>{ReactHtmlParser(abstract)}</p>}
  </>
)

const AddRatingSectorOutlooks = ({
  sectorOutlookCode,
  sectorOutlook,
  isPrintPreview,
  outlookIconClick
}: any) => {
  return (
    <>
      {sectorOutlookCode ? (
        <>
          Sector Outlook:&nbsp;
          {isPrintPreview ? (
            `${sectorOutlook}`
          ) : (
            <span
              className={`frw-${sectorOutlookCode}`}
              onClick={outlookIconClick}
              role="button"
              onKeyDown={onButtonTriggerKey(outlookIconClick)}
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            />
          )}
          <br />
        </>
      ) : null}
      {sectorOutlookCode ? (
        <>
          <br />
        </>
      ) : null}
    </>
  )
}

const renderItem = (
  {
    text,
    ultimateParent,
    publishedDate,
    docType,
    reportType,
    abstract,
    marketing,
    entityName,
    entityRatings = [],
    permalink,
    sectorOutlook,
    sectorOutlookCode,
    renderLink: Link,
    title,
    name,
    issueName,
    transactionTitle,
    ...props
  }: ResultItemProps,
  isPrintPreview: boolean,
  outlookIconClick: () => void
) => {
  const isJapanese = get(marketing, 'language.slug') === 'ja'

  const reportTypeHeader =
    isJapanese &&
    reportType &&
    (reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY' ||
      reportType.toUpperCase() === 'RATING ACTION COMMENTARY')
      ? 'Commentary'
      : reportType

  return (
    <div className="frw-column" key={permalink}>
      <div className="frw-heading--sub frw-heading--tag">
        <span
          className={
            get(marketing, 'contentAccessType.name') === 'Premium'
              ? 'frw-premium-report__color'
              : ''
          }
        >
          {docType === 'FW' &&
          reportType &&
          reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY'
            ? 'Fitch Wire'
            : reportTypeHeader && `${reportTypeHeader}`}
        </span>
        {reportTypeHeader && ` / `}

        {publishedDate && FormatDate(publishedDate, 'ccc dd MMM, yyyy')}
        {entityRatings && !text && !abstract ? 'Entity' : null}
        {permalink && includes(permalink, 'credit-summary')
          ? ' - Credit Summary'
          : null}
        {ultimateParent ? ' - Ultimate Parent' : null}
        {entityName && ` / ${entityName}`}
      </div>
      <h3 className="frw-heading--5">
        <Link
          {...props}
          permalink={permalink}
          title={title || name || issueName || transactionTitle}
        />
      </h3>
      <AddRatingSectorOutlooks
        sectorOutlookCode={sectorOutlookCode}
        sectorOutlook={sectorOutlook}
        isPrintPreview={isPrintPreview}
        outlookIconClick={outlookIconClick}
      />
      <TextAbstract text={text} abstract={abstract} />
      {isEmpty(entityRatings) && !text && !abstract ? <p>-</p> : null}
      {!text && !abstract ? <GridViewEntity items={entityRatings} /> : null}
    </div>
  )
}

export class ResultItems extends React.Component<ResultItemsProps> {
  state = {
    showOutlookPopup: false
  }

  render() {
    const { items, isPrintPreview = false } = this.props
    const { showOutlookPopup } = this.state
    const outlookIconClick = () => {
      this.setState({ showOutlookPopup: !showOutlookPopup })
    }
    return (
      <div className="frw-column__main">
        <div className="frw-column__three frw-column--merge-a">
          {items
            ? items.map((item) =>
                renderItem(item, isPrintPreview, outlookIconClick)
              )
            : null}
          {showOutlookPopup && <OutlookPopup handleClick={outlookIconClick} />}
        </div>
      </div>
    )
  }
}
